

























































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {InputText, InputCheckbox, Resource} from 'simpli-web-sdk'
import {TipoDocumento} from '@/enums/TipoDocumento'
import {Responsavel} from '@/model/resource/Responsavel'
import {ValidatorHelper} from '@/helpers/ValidatorHelper'

@Component({
  components: {InputText, InputCheckbox},
})
export default class InputTipoDocumento extends Vue {
  @Prop({type: Object, required: true}) model!: Responsavel

  options: Resource[] = []

  TipoDocumento = TipoDocumento

  valid = true

  created() {
    this.options = Object.entries(TipoDocumento)
      .filter(([key, value]) => !isNaN(Number(key)))
      .map(
        ([key, value]) =>
          ({
            $id: Number(key),
            $tag: value,
          } as Resource)
      )
  }

  get computedModel() {
    return this.model.loginPorDocumento
  }

  set computedModel(val: boolean) {
    this.$emit('input', val)
  }

  get isDisabled() {
    return this.model.idResponsavelPk !== 0
  }

  validateDocument() {
    if (this.model.cnpj && !this.isDisabled) {
      this.valid =
        ValidatorHelper.isCnpj(this.model.cnpj) ||
        ValidatorHelper.isCpf(this.model.cnpj)
      this.$emit('inputDocument')
    }
  }
}
